import React from "react";
import { Grid, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { validateStep1 } from "../SignUp/Validation";
import { addUserValidate } from "../Profile/validate";
import { LocalizationProvider } from "@mui/x-date-pickers";

interface BirthDatePickerProps {
  addUser?: boolean;
  errorField?: string;
  errors: any;
  label?: string;
  margin?: 'none' | 'dense' | 'normal';
  openTo?: 'year' | 'month' | 'day';
  required?: boolean;
  selectedDate: any;
  variant?: 'standard' | 'outlined' | 'filled';
  views?: Array<'year' | 'month' | 'day'>;
  customValidation?: (value: any) => any;
  handleDateChange: (value: any) => void;
  setErrors: (errors: any) => void;
}

const BirthDatePicker = (props: BirthDatePickerProps) => {
  const {
    addUser,
    errorField = 'dob',
    errors,
    label = 'Date of birth',
    margin = 'none',
    openTo = 'year',
    required = true,
    selectedDate,
    variant = 'standard',
    views = ['year', 'month', 'day'],
    customValidation,
    setErrors,
    handleDateChange,
  } = props;

  const validateDate = (value: any) => {
    if (customValidation) {
      return customValidation(value);
    }
    
    const dateValue = value?.$d ? value.$d : value;
    
    if (addUser) {
      return addUserValidate({ [errorField]: dateValue });
    } else {
      return validateStep1({ [errorField]: dateValue });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container justifyContent="space-around">
        <DatePicker
          openTo={openTo}
          label={label}
          views={views}
          value={selectedDate ? dayjs(selectedDate) : null}
          maxDate={dayjs()}
          minDate={dayjs("1900-01-01")}
          onChange={(newValue) => {
            const isValid = validateDate(newValue);
            handleDateChange(newValue);
            setErrors({
              ...errors,
              [errorField]: isValid[errorField],
            });
          }}
          slotProps={{
            textField: {
              required: required,
              helperText: errors[errorField],
              error: Boolean(errors[errorField]),
              color: "secondary",
              margin: margin,
              fullWidth: true,
              variant: variant,
              InputLabelProps: {
                shrink: true
              },
            }
          }}
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default BirthDatePicker;